import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface Props {
  images: string[];
  alt: string;
  /** When a variant changes the product image, jump to it. */
  activeImage?: string;
  badges?: React.ReactNode;
}
export function ProductGallery({
  images,
  alt,
  activeImage,
  badges
}: Props) {
  const all = activeImage && !images.includes(activeImage) ? [activeImage, ...images] : images;
  const [current, setCurrent] = useState(activeImage ?? all[0]);
  useEffect(() => {
    if (activeImage) setCurrent(activeImage);
  }, [activeImage]);
  return <div className="flex flex-col-reverse gap-3 md:flex-row" data-id="element-339" data-mp="1phe3akovruw6">
      {all.length > 1 && <ul className="flex gap-2.5 md:flex-col" aria-label="Product images" data-id="element-340" data-mp="1ti7qtcyev7oj">
          {all.map((src, i) => <li key={src} data-id="element-341" data-mp="3junhgpsdg4kr" data-mpi={i}>
              <button type="button" onClick={() => setCurrent(src)} aria-label={`Show image ${i + 1}`} aria-current={current === src} className={`block h-16 w-16 overflow-hidden rounded-lg bg-surface transition-shadow duration-150 md:h-20 md:w-20 ${current === src ? 'ring-2 ring-ink' : 'ring-1 ring-line hover:ring-ink/30'}`} data-id="element-342" data-mp="3jvf2x7s98lxb">
                <img src={src} alt="" className="h-full w-full object-cover" data-id="element-343" data-mp="1bkkbxqniytly" />
              </button>
            </li>)}
        </ul>}
      <div className="relative aspect-square flex-1 overflow-hidden rounded-2xl bg-surface" data-id="element-344" data-mp="nvro6hh23s2f">
        <AnimatePresence initial={false} data-id="element-345" data-mp="ixzlcseviljg">
          <motion.img key={current} src={current} alt={alt} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="absolute inset-0 h-full w-full object-cover" data-id="element-346" data-mp="xtfjb8ikr1l4" />
        </AnimatePresence>
        {badges && <div className="absolute left-4 top-4 flex gap-1.5" data-id="element-347" data-mp="24c3ztnv2gvua">{badges}</div>}
      </div>
    </div>;
}